module.exports = __webpack_public_path__ + "img/一键部署icon.c774da45.png";